import { IntegrationEventItem } from '@zond/api-interfaces';
import { ChevronDown, ChevronRight } from 'lucide-react';
import React, { useState } from 'react';

interface CollapsibleEventSectionProps {
  title: string;
  icon: React.ReactNode;
  events: IntegrationEventItem[];
  renderEvent: (event: IntegrationEventItem) => React.ReactNode;
  defaultExpanded?: boolean;
}

export const CollapsibleEventSection: React.FC<CollapsibleEventSectionProps> = ({
  title,
  icon,
  events,
  renderEvent,
  defaultExpanded = true,
}) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  if (events.length === 0) return null;

  return (
    <div className="space-y-2">
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="flex items-center gap-2 text-sm font-medium text-muted-foreground hover:text-foreground transition-colors w-full"
      >
        {isExpanded ? <ChevronDown className="h-4 w-4" /> : <ChevronRight className="h-4 w-4" />}
        {icon}
        <span>{title}</span>
        <span className="text-xs">({events.length})</span>
      </button>
      {isExpanded && (
        <div className="space-y-1 max-h-[150px] overflow-y-auto custom-scrollbar pl-6">
          {events.map(renderEvent)}
        </div>
      )}
    </div>
  );
};
